package net.bothosting.docs.pages.community_resources

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initUseful_repositoriesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("community_resources/useful_repositories.md", FrontMatterElement.Builder { addScalar("description", "Created by @kipbo"); }))
}

@Page("/community_resources/useful-repositories")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Useful_repositoriesPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("useful-repositories") }) {
        org.jetbrains.compose.web.dom.Text("Useful Repositories")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thanks to ♻ ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://codump.github.io/") {
            org.jetbrains.compose.web.dom.Text("codump")
        }
        org.jetbrains.compose.web.dom.Text(" ♻ !")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("djs-v14-empty-start") }) {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/djs-v14-empty-start") {
            org.jetbrains.compose.web.dom.Text("djs-v14-empty-start")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Repository link: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/djs-v14-empty-start") {
                org.jetbrains.compose.web.dom.Text("https://github.com/codump/djs-v14-empty-start")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Start for discord bot. From the d.js guide with a minor edit to commands, there are no subfolders. Instructions can be found in the guide. You don't have to code, only follow the setup instructions. Also change ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("empty-config.json")
        }
        org.jetbrains.compose.web.dom.Text(" to ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("config.json")
        }
        org.jetbrains.compose.web.dom.Text(" and fill in the details.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("discord-js-v14-basic-bot-functions") }) {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/discord.js-v14-basic-bot-functions") {
            org.jetbrains.compose.web.dom.Text("Discord.js v14 basic bot functions")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Repository link: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/discord.js-v14-basic-bot-functions") {
                org.jetbrains.compose.web.dom.Text("https://github.com/codump/discord.js-v14-basic-bot-functions")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Installation and usage information can be found ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/discord.js-v14-basic-bot-functions/blob/main/README.md") {
                org.jetbrains.compose.web.dom.Text("here")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("features") }) {
        org.jetbrains.compose.web.dom.Text("Features")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The new slash commands.")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/serverinfo")
                    }
                    org.jetbrains.compose.web.dom.Text(" Information about the server.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/automsgmention")
                    }
                    org.jetbrains.compose.web.dom.Text(" Automated message with mention.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/code")
                    }
                    org.jetbrains.compose.web.dom.Text(" How to use code on discord.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/jsfiddle")
                    }
                    org.jetbrains.compose.web.dom.Text(" Ask to start a jsfiddle.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/kick")
                    }
                    org.jetbrains.compose.web.dom.Text(" Kick a member.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/ban")
                    }
                    org.jetbrains.compose.web.dom.Text(" Ban a member.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("/warning")
                    }
                    org.jetbrains.compose.web.dom.Text(" Warn a member and store it in DB.")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Auto roles.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Join and leave notification.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notification when someone starts streaming on discord.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("GitHub notifications. ")
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("sup", attrs = {}) {
                org.jetbrains.compose.web.dom.Text("(Releases, push, pull and more depending on your gh webhook settings.)")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ticket channel system.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("basic-express-and-ejs-with-api") }) {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/basic-express-ejs-with-api") {
            org.jetbrains.compose.web.dom.Text("Basic Express and EJS with API")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Repository Link: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/basic-express-ejs-with-api") {
                org.jetbrains.compose.web.dom.Text("https://github.com/codump/basic-express-ejs-with-api")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Installation and usage information can be found ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/codump/basic-express-ejs-with-api/blob/main/README.md") {
            org.jetbrains.compose.web.dom.Text("here")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("discord-js-basic-bot-hosting-net-server-api-slash-commands") }) {
        com.varabyte.kobweb.silk.components.navigation.Link("https://codump.github.io/code/bot-hosting-net-server-api/") {
            org.jetbrains.compose.web.dom.Text("Discord.js basic Bot-Hosting.net server API slash commands")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Website Link: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://codump.github.io/code/bot-hosting-net-server-api/") {
                org.jetbrains.compose.web.dom.Text("https://codump.github.io/code/bot-hosting-net-server-api/")
            }
        }
    }
}
